// Sprint 11 A2: Briefing Headline Widget
import { formatCurrency, formatNumber } from "@/lib/i18n";

interface HeadlineProps {
  pipelineValueCents: number;
  closingThisWeek: number;
  closingValueCents: number;
  atRiskCount: number;
  newLeadsOvernight: number;
  summary: string;
}

export function BriefingHeadlineWidget(props: HeadlineProps) {
  if (!props.summary && props.pipelineValueCents === 0) {
    return <div className="text-center text-[var(--color-muted-foreground)] py-4">Generating your briefing...</div>;
  }

  return (
    <div className="bg-[var(--color-surface)]/50 rounded-xl p-6">
      <div className="text-lg font-semibold text-[var(--color-foreground)] mb-3">
        {props.summary || `${formatBriefingCurrency(props.pipelineValueCents)} in pipeline`}
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <Stat label="Pipeline" value={formatBriefingCurrency(props.pipelineValueCents)} />
        <Stat label="Closing this week" value={`${formatNumber(props.closingThisWeek)} (${formatBriefingCurrency(props.closingValueCents)})`} />
        <Stat label="At risk" value={formatNumber(props.atRiskCount)} color={props.atRiskCount > 0 ? "text-[var(--color-destructive)]" : undefined} />
        <Stat label="New leads overnight" value={formatNumber(props.newLeadsOvernight)} color={props.newLeadsOvernight > 0 ? "text-[var(--color-success)]" : undefined} />
      </div>
    </div>
  );
}

function formatBriefingCurrency(cents: number): string {
  return formatCurrency(cents, "EUR", { maximumFractionDigits: 0 });
}

function Stat({ label, value, color }: { label: string; value: string; color?: string }) {
  return (
    <div>
      <div className="text-xs text-[var(--color-muted-foreground)]">{label}</div>
      <div className={`text-lg font-bold ${color ?? "text-[var(--color-foreground)]"}`}>{value}</div>
    </div>
  );
}
